import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const without = ['Improvisas la clase', 'Un solo plan para todos', 'Evalúas “a ojo”', 'Siempre los mismos ejercicios', 'Horas preparando cada sesión', 'Alumnos que abandonan'];
const with_ = ['Clases ya estructuradas', 'Adaptación por patología', 'Fichas y reevaluación', 'Progresiones por zona', 'Abres el PDF y aplicas', 'Renuevan al ver su avance'];
export function Comparison() {
  return <section className="px-5 py-8" aria-labelledby="comparativa-title" data-id="element-49" data-mp="1zwa6muijmcfn">
      <h2 id="comparativa-title" className="text-center font-display text-[21px] leading-snug text-[#16302a]" data-id="element-50" data-mp="1zuh2pmzbe6bc">
        Sin Gimnasia Postural Resuelta <span className="text-[#6f8f7c]" data-id="element-51" data-mp="28xi6vi4mdncd">vs</span> Con Gimnasia Postural Resuelta
      </h2>

      <div className="mt-4 grid grid-cols-2 gap-2" data-id="element-52" data-mp="9k4bfksecewi">
        <div className="rounded-2xl border border-[#e0cfc7] bg-white/85 p-2.5 backdrop-blur-sm" data-id="element-53" data-mp="9lfh5q5ejwq9">
          <p className="mb-2 text-center text-[10.5px] font-extrabold uppercase leading-tight tracking-wide text-[#b4553f]" data-id="element-54" data-mp="ejh5aphoqm8l">
            Sin Gimnasia
            <br data-id="element-55" data-mp="1h9h1xcrszq0s" />
            Postural Resuelta
          </p>
          <ul className="space-y-1.5" data-id="element-56" data-mp="1h7w67jtr611c">
            {without.map(item => <li key={item} className="flex gap-1.5" data-id="element-57" data-mp="1d8x4s978cmen">
                <XIcon className="mt-[2px] h-3.5 w-3.5 shrink-0 text-[#b4553f]" aria-hidden="true" data-id="element-58" data-mp="189kgdk0pn79y" />
                <span className="text-[11.5px] leading-[1.25] text-[#5b504c]" data-id="element-59" data-mp="25039z41t5aas">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-2xl border-2 border-[#3f5d4e] bg-[#3f5d4e] p-2.5" data-id="element-60" data-mp="20yrg2mbwi2ws">
          <p className="mb-2 text-center text-[10.5px] font-extrabold uppercase leading-tight tracking-wide text-[#dfe9e0]" data-id="element-61" data-mp="1vxlq2w9mktqy">
            Con Gimnasia
            <br data-id="element-62" data-mp="kjggnnqn7ro8" />
            Postural Resuelta
          </p>
          <ul className="space-y-1.5" data-id="element-63" data-mp="kl1atc91p8lk">
            {with_.map(item => <li key={item} className="flex gap-1.5" data-id="element-64" data-mp="fjvhbc7k9haz">
                <CheckIcon className="mt-[2px] h-3.5 w-3.5 shrink-0 text-[#b8d9c2]" aria-hidden="true" data-id="element-65" data-mp="h1splvdfwzgr" />
                <span className="text-[11.5px] leading-[1.25] text-[#f0f5f0]" data-id="element-66" data-mp="m0n96zj8es1x">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}